import { render, staticRenderFns } from "./ProformaModal.vue?vue&type=template&id=5bb51234&scoped=true&"
import script from "./ProformaModal.vue?vue&type=script&lang=ts&"
export * from "./ProformaModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProformaModal.vue?vue&type=style&index=0&id=5bb51234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb51234",
  null
  
)

export default component.exports